import { render, staticRenderFns } from "./TheMyOrdersTableDetails.vue?vue&type=template&id=54685d34&scoped=true"
import script from "./TheMyOrdersTableDetails.vue?vue&type=script&lang=js"
export * from "./TheMyOrdersTableDetails.vue?vue&type=script&lang=js"
import style0 from "./TheMyOrdersTableDetails.vue?vue&type=style&index=0&id=54685d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54685d34",
  null
  
)

export default component.exports